/**
 * The file name a Content-Disposition header offers, or null.
 *
 * Prefers the RFC 5987 `filename*=UTF-8''...` form when both are present, since
 * that is the one that can carry a non-ASCII name; falls back to the plain
 * `filename="..."` (quoted or not).
 */
export function fileNameFromDisposition(header) {
    if (!header) return null;

    const extended = /filename\*\s*=\s*([\w-]+)?'[^']*'([^;]+)/i.exec(header);
    if (extended) {
        try {
            const name = decodeURIComponent(extended[2].trim().replace(/^"|"$/g, ''));
            if (name) return name;
        } catch (e) {
            // A malformed escape: the plain form below is still worth a try.
        }
    }

    const plain = /filename\s*=\s*(?:"([^"]*)"|([^;]+))/i.exec(header);
    const name = plain ? (plain[1] ?? plain[2] ?? '').trim() : '';
    return name || null;
}

/** Hands a Blob to the browser as a download named `fileName`. */
export function saveBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    // Revoked on the next tick: some browsers start the download only after the
    // click handler returns, and an already-revoked URL downloads nothing.
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
